<template>
  <div>
    <div v-if="!showClPup"  class="GmzHqsjfxTable">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="width: calc(100% - 225px)"
            :model="formInline"
            label-position="right"
            label-width="90px"
          >
            <el-row>
              <el-col :span="8">
                <el-form-item label="购买证编号:">
                  <el-input v-model="formInline.xkzBh" placeholder="请输入完整的编号"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="化学品名称:">
                  <el-select v-model="formInline.hxpBms" filterable multiple placeholder="请选择(可多选)">
                    <el-option
                      v-for="item in hxpList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="处置状态:" >
                  <el-select v-model="formInline.zt" placeholder="请选择">
                    <el-option
                      v-for="item in ztList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="核发时间:">
                  <el-date-picker
                    v-model="formInline.beginHfrq"
                    style="width: 45%"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择"
                  />
                  -
                  <el-date-picker
                    v-model="formInline.endHfrq"
                    style="width: 45%"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="width:225px">
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              size="small"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh-left"
              round
              size="small"
              @click="resetDataSource"
            >重置</el-button>
          </div>

        </div>
      </div>
      <div
        style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;"
      >
        <div class="tablemes">
          <div
            style="
            background-color: #f2f2f2;
            padding: 10px;
            border: 1px solid #f2f2f2;
          "
          >
            <el-button
              v-preventReClick
              icon="el-icon-upload2"
              size="mini"
              @click="dcexcel"
            >导出</el-button>
            <el-button
              v-if="dczCount != 0"
              v-preventReClick
              icon="el-icon-coordinate"
              type="primary"
              size="mini"
              @click="dealDczData"
            >处理</el-button>
            <el-tag :type="dczCount == 0?'success':'danger'">{{dczCount}}条待处理数据</el-tag>
          </div>
          <el-table
            ref="gmzHqfxTabel"
            :data="tableData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              width="170"
              prop="xkzBh"
              label="购买证编号"
            />
            <el-table-column
              width="170"
              prop="hfrq"
              label="核发时间"
            />
            <el-table-column
              prop="hxpMc"
              label="化学品"
            />
            <el-table-column
              label="核准数量"
            >
              <template slot-scope="scope">
                {{ scope.row["hzsl"] +
                "  (" +
                scope.row["hzslDwLabel"] +
                ")" }}
              </template>
            </el-table-column>
            <el-table-column
              label="单价"
            >
              <template slot-scope="scope">
                {{ scope.row["dj"] +
                "  (" +
                scope.row["djDwLabel"] +
                ")" }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="gmdwProvinceLabel"
              label="购买单位省份"
            />
            <el-table-column
              width="120"
              prop="xsdwProvinceLabel"
              label="销售单位省份"
            />
            <el-table-column
              width="120"
              prop="htqdRq"
              label="合同签订日期"
            />
            <el-table-column
              prop="jhrq"
              label="交货日期"
            />
            <el-table-column
              prop="ztLabel"
              label="状态"
            >
              <template slot-scope="scope">
                <span :style="scope.row.zt == '1'?'color:green':''">{{scope.row.ztLabel}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100px">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.zt == '1'"
                  v-preventReClick
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="editUpd(scope.row)"
                >修改</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <GmzHqsjfxTableCl v-if="showClPup" :data-id="dataId" :edit-flag="editFlag"/>
  </div>
</template>

<script>
import { getHxpListByLevel4, getTableListData, exportTableListData, getTableDczCount } from '@/assets/js/gmzHqsjfx'
import GmzHqsjfxTableCl from "@/components/gmzHqsjfxTable/GmzHqslfxTableCL";
export default {
  name: 'GmzHqsjfxTableList',
  components: {GmzHqsjfxTableCl},
  data() {
    return {
      showClPup: false,
      dataId:'',
      editFlag:false,
      formInline: { // 搜索表单
        xkzBh:'',
        hxpBms: [],
        beginHfrq: '',
        endHfrq: '',
        zt:''
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 列表总数
      dczCount: 0, // 待处置条数
      tableData: [], // 表格数据
      hxpList: [],
      ztList: [
        {
          value:'0',
          label:'未处理'
        },
        {
          value:'1',
          label:'已处理'
        }
      ]
    }
  },
  mounted() {
    getHxpListByLevel4().then(res => {
      this.hxpList = []
      if (res.status === 200 && res.data.code === '000000') {
        this.hxpList = res.data.data
      }
    })
    this.loadDatasource()
  },
  methods: {
    editUpd(row){
      this.showClPup = true
      this.editFlag = true
      this.dataId = row.id
    },
    dealDczData(){
      this.showClPup = true
    },
    dcexcel() {
      this.$message.info('正在导出中...')
      exportTableListData({
        param: this.formInline
      }).then((e) => {
        this.$message.success('导出成功!')
        const table = '行情数据表分析'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 查询列表数据
    loadDatasource() {
      getTableDczCount().then((e) => {
        this.dczCount = e.data.data
      })
      getTableListData({
        page: this.currentPage,
        size: this.pagesize,
        param: this.formInline
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadDatasource()
    },
    // 重置
    resetDataSource() {
      this.formInline = this.$options.data().formInline,
      this.loadDatasource()
    }
  }
}
</script>

<style scoped lang='less'>
  .GmzHqsjfxTable {
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .sousuo {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: space-between;
      }
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
